import { API_URL } from '../config';

/** Bump to invalidate Cloudflare/browser 404 cache after origin outages. */
const IMG_CACHE_BUST = 'v=4';

function withCacheBust(src) {
    if (!src) return src;
    const sep = src.includes('?') ? '&' : '?';
    return `${src}${sep}${IMG_CACHE_BUST}`;
}

/** Product files live on the store host. Local API has no uploads/products copy. */
const UPLOADS_ORIGIN = import.meta.env.DEV ? 'https://erp.supercolchagua.cl' : '';

/** Build the public URL for a product photo stored as /uploads/... */
export function productImageSrc(fotoUrl) {
    const u = fotoUrl && String(fotoUrl).trim();
    if (!u) return null;
    if (u.startsWith('http')) return withCacheBust(u);
    const path = u.startsWith('/') ? u : `/${u}`;
    const origin = path.startsWith('/uploads/') && UPLOADS_ORIGIN ? UPLOADS_ORIGIN : API_URL;
    return withCacheBust(`${origin}${path}`);
}

/**
 * One retry with a cache-buster. Browsers (and Cloudflare) can keep a 404
 * from a brief origin outage even after the file is back on disk.
 */
export function retryProductImageOnce(event) {
    const img = event.currentTarget;
    if (!img || img.dataset.retried === '1') return;
    img.dataset.retried = '1';
    try {
        const url = new URL(img.src, window.location.origin);
        url.searchParams.set('retry', '1');
        img.src = url.toString();
    } catch {
        // ignore malformed src
    }
}
